const SYMBOL_MAP = {
  "&": " and ",
  "@": " at ",
  "+": " plus ",
  "=": " equals ",
  "%": " percent ",
  "₹": " rupees ",
  $: " dollars ",
  "€": " euros ",
  "£": " pounds ",
  "¥": " yen ",
  "<": " less than ",
  ">": " greater than ",
  "°": " degrees ",
  "±": " plus or minus ",
  "×": " times ",
  "÷": " divided by ",
  "©": " copyright ",
  "™": " trademark ",
  "→": " leads to ",
  "←": " points to the left ",
  "↑": " up ",
  "↓": " down ",
  "•": " ",
  "·": " ",
  "−": " minus ",
  "–": " ",
  "—": " — ",
  "√": " square root of ",
  "∞": " infinity ",
  "½": " half ",
  "¼": " one quarter ",
  "¾": " three quarters ",
};

const ABBREVIATION_MAP = {
  "www.": "world wide web ",
  "http://": "",
  "https://": "",
  "e.g.": "for example",
  "i.e.": "that is",
  "vs.": "versus",
  "etc.": "et cetera",
  "no.": "number",
  "a.m.": "a m",
  "p.m.": "p m",
  km: "kilometers",
  cm: "centimeters",
  mm: "millimeters",
  kg: "kilograms",
  g: "grams",
  l: "liters",
  ml: "milliliters",
  hr: "hours",
  min: "minutes",
  sec: "seconds",
  FAQ: "f a q",
  API: "a p i",
  URL: "u r l",
  ID: "i d",
  // Brand name — always spoken as one word ("mivent"), never spelled out
  MIVENT: "mivent",
};

const EMOJI_MAP = {
  "😀": " happy ",
  "😄": " happy ",
  "😊": " smiling ",
  "😃": " happy ",
  "😁": " grinning ",
  "🙂": " smiling ",
  "😉": " winking ",
  "😍": " in love ",
  "🥰": " loved ",
  "😎": " cool ",
  "🤔": " thinking ",
  "🤗": " hugging ",
  "😅": " relieved ",
  "😂": " laughing ",
  "🤣": " laughing hard ",
  "😢": " sad ",
  "😭": " crying ",
  "😡": " angry ",
  "😠": " angry ",
  "😱": " shocked ",
  "😮": " surprised ",
  "😴": " sleepy ",
  "👍": " thumbs up ",
  "👎": " thumbs down ",
  "👏": " clapping ",
  "🙌": " celebrating ",
  "🙏": " praying ",
  "💪": " strong ",
  "🤝": " handshake ",
  "✌️": " peace ",
  "👌": " okay ",
  "💡": " idea ",
  "❤️": " heart ",
  "💖": " love ",
  "✨": " sparkles ",
  "⭐": " star ",
  "🌟": " star ",
  "🔥": " fire ",
  "🎉": " celebration ",
  "🎊": " celebration ",
  "🎯": " target ",
  "🚀": " rocket ",
  "✅": " yes ",
  "❌": " no ",
  "⚠️": " warning ",
  "📅": " calendar ",
  "⏰": " alarm ",
  "📈": " trending up ",
  "📉": " trending down ",
  "💰": " money ",
  "🏆": " trophy ",
  "🎁": " gift ",
  "📦": " package ",
  "📧": " email ",
  "📱": " mobile ",
  "💬": " message ",
  "📝": " notes ",
  "🔗": " link ",
  "⚡": " lightning ",
  "☀️": " sun ",
  "🌧️": " rain ",
  "🍀": " lucky ",
  "🎵": " music ",
  "👀": " attention ",
  "🧠": " brain ",
  "📊": " chart ",
  "🗓️": " calendar ",
};

function stripEmojis(text) {
  return text
    .replace(
      /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{1F000}-\u{1F0FF}]/gu,
      (match) => EMOJI_MAP[match] || " ",
    )
    .replace(/[\u{1F1E6}-\u{1F1FF}]+/gu, " ");
}

function stripMarkdown(text) {
  return text
    .replace(/```[\s\S]*?```/g, " code block. ")
    .replace(/`([^`]+)`/g, " $1 ")
    .replace(/\*\*\*([^*]+)\*\*\*/g, " $1 ")
    .replace(/\*\*([^*]+)\*\*/g, " $1 ")
    .replace(/\*([^*]+)\*/g, " $1 ")
    .replace(/__([^_]+)__/g, " $1 ")
    .replace(/^#{1,6}\s+/gm, " ")
    .replace(/^>\s+/gm, " ")
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, " $1 ")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, " $1 ")
    .replace(/^[-*+]\s+/gm, " ")
    .replace(/^\s*\d+\.\s+/gm, " ")
    .replace(/[|]+/g, " ")
    .replace(/^[-=]+$/gm, " ")
    .replace(/\^([^^]+)\^/g, " $1 ")
    .replace(/~~([^~]+)~~/g, " $1 ");
}

// ── Indian rupees to words (hundred/thousand/lakh/crore) for natural WaveNet/browser reading
const ONES_EN_TTS = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
const TENS_EN_TTS = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
function belowHundredEnTts(n){ if(n<20) return ONES_EN_TTS[n]; const t=Math.floor(n/10), o=n%10; return TENS_EN_TTS[t]+(o?" "+ONES_EN_TTS[o]:""); }
function belowThousandEnTts(n){ if(n<100) return belowHundredEnTts(n); const h=Math.floor(n/100), r=n%100; return ONES_EN_TTS[h]+" hundred"+(r?" "+belowHundredEnTts(r):""); }
function numberToIndianWordsEnTts(num){ if(num===0) return "zero"; let r=""; const cr=Math.floor(num/10000000); if(cr){ r+=belowThousandEnTts(cr)+" crore"; num%=10000000; if(num) r+=" "; } const lk=Math.floor(num/100000); if(lk){ r+=belowThousandEnTts(lk)+" lakh"; num%=100000; if(num) r+=" "; } const th=Math.floor(num/1000); if(th){ r+=belowThousandEnTts(th)+" thousand"; num%=1000; if(num) r+=" "; } if(num) r+=belowThousandEnTts(num); return r.trim(); }
function rupeesToWordsEnTts(s){ const c=s.replace(/,/g,"").trim(); const n=parseFloat(c); if(isNaN(n)) return s; const abs=Math.abs(n); const rs=Math.floor(abs); const ps=Math.round((abs-rs)*100); let w=numberToIndianWordsEnTts(rs)+(rs===1?" rupee":" rupees"); if(ps) w+=" and "+numberToIndianWordsEnTts(ps)+(ps===1?" paise":" paise"); if(n<0) w="minus "+w; return w; }
const ONES_KN_TTS = ["", "ಒಂದು", "ಎರಡು", "ಮೂರು", "ನಾಲ್ಕು", "ಐದು", "ಆರು", "ಏಳು", "ಎಂಟು", "ಒಂಬತ್ತು", "ಹತ್ತು", "ಹನ್ನೊಂದು", "ಹನ್ನೆರಡು", "ಹದಿಮೂರು", "ಹದಿನಾಲ್ಕು", "ಹದಿನೈದು", "ಹದಿನಾರು", "ಹದಿನೇಳು", "ಹದಿನೆಂಟು", "ಹತ್ತೊಂಬತ್ತು"];
const TENS_KN_TTS = ["", "", "ಇಪ್ಪತ್ತು", "ಮೂವತ್ತು", "ನಲವತ್ತು", "ಐವತ್ತು", "ಅರವತ್ತು", "ಎಪ್ಪತ್ತು", "ಎಂಬತ್ತು", "ತೊಂಬತ್ತು"];
function belowHundredKnTts(n){ if(n<20) return ONES_KN_TTS[n]; const t=Math.floor(n/10), o=n%10; return TENS_KN_TTS[t]+(o?" "+ONES_KN_TTS[o]:""); }
function belowThousandKnTts(n){ if(n<100) return belowHundredKnTts(n); const h=Math.floor(n/100), r=n%100; return ONES_KN_TTS[h]+" ನೂರು"+(r?" "+belowHundredKnTts(r):""); }
function numberToIndianWordsKnTts(num){ if(num===0) return "ಸೊನ್ನೆ"; let r=""; const cr=Math.floor(num/10000000); if(cr){ r+=belowThousandKnTts(cr)+" ಕೋಟಿ"; num%=10000000; if(num) r+=" "; } const lk=Math.floor(num/100000); if(lk){ r+=belowThousandKnTts(lk)+" ಲಕ್ಷ"; num%=100000; if(num) r+=" "; } const th=Math.floor(num/1000); if(th){ r+=belowThousandKnTts(th)+" ಸಾವಿರ"; num%=1000; if(num) r+=" "; } if(num) r+=belowThousandKnTts(num); return r.trim(); }
function rupeesToWordsKnTts(s){ const c=s.replace(/,/g,"").trim(); const n=parseFloat(c); if(isNaN(n)) return s; const abs=Math.abs(n); const rs=Math.floor(abs); const ps=Math.round((abs-rs)*100); let w=numberToIndianWordsKnTts(rs)+" ರೂಪಾಯಿ"; if(ps) w+=" ಮತ್ತು "+numberToIndianWordsKnTts(ps)+" ಪೈಸೆ"; if(n<0) w="ಮೈನಸ್ "+w; return w; }
function formatRupeesForLangTts(amt, lang){ return lang==="kn-IN"? rupeesToWordsKnTts(amt): rupeesToWordsEnTts(amt); }

function expandSymbols(text, lang = "en-IN") {
  // Convert ₹ / Rs. amounts to Indian words first (hundred/thousand/lakh/crore)
  let t = text;
  t = t.replace(/₹\s*([\d,]+(?:\.\d{1,2})?)/g, (_, amt) => " " + formatRupeesForLangTts(amt, lang) + " ");
  t = t.replace(/\bRs\.?\s*([\d,]+(?:\.\d{1,2})?)/gi, (_, amt) => " " + formatRupeesForLangTts(amt, lang) + " ");
  return t
    .split(" ")
    .map((word) => {
      if (/^\d+([.,]\d+)?$/.test(word)) return word;
      if (word.length > 20) return word;
      if (/^[A-Z]{2,}$/.test(word)) {
        const expanded = ABBREVIATION_MAP[word];
        return expanded || word.split("").join(" ");
      }
      return word;
    })
    .join(" ")
    .replace(/&/g, " and ")
    .replace(/#\s?(\d+)/g, " number $1")
    .replace(/(\d+)\s*(%|percent)/g, " $1 percent ")
    .replace(/\$\s?(\d+)/g, " dollars $1 ")
    .replace(/[\/\\]/g, " ")
    // Keep sentence terminals (. ! ?) for prosody — only collapse dot runs.
    .replace(/\.{2,}/g, ".")
    .replace(/\s{2,}/g, " ")
    .trim();
}

function replaceSpeechTokens(text) {
  let result = text;
  const tokens = Object.entries(ABBREVIATION_MAP).sort(
    ([first], [second]) => second.length - first.length,
  );

  for (const [token, replacement] of tokens) {
    const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const boundary = /^[A-Za-z]+$/.test(token) ? "\\b" : "";
    result = result.replace(
      new RegExp(`${boundary}${escapedToken}${boundary}`, "gi"),
      replacement,
    );
  }

  return result;
}

function smartSpeechText(raw, lang = "en-IN") {
  let text = String(raw || "");
  // Structural breaks first: bullets / numbered lists / newlines → pauses
  text = text.replace(/^\s*[•·▪▫\-–—*]+\s+/gm, "");
  text = text.replace(/^\s*\d+[.)]\s+/gm, "");
  text = text.replace(/\r?\n+/g, ". ");
  text = text.replace(/([.!?])\s*[.!?]+/g, "$1 ");
  text = text.replace(/([.!?])\1+/g, "$1");
  text = stripMarkdown(text);
  text = stripEmojis(text);
  for (const [token, replacement] of Object.entries(SYMBOL_MAP)) {
    if (token === "₹") continue; // handled as Indian words in expandSymbols
    text = text.split(token).join(replacement);
  }
  text = replaceSpeechTokens(text);
  text = expandSymbols(text, lang);
  // Normalize spacing around punctuation for natural prosody
  // Ensure single space after .!? and comma, avoid run-on
  text = text
    .replace(/\s+([,.!?;:])/g, "$1")
    .replace(/([,.!?;:])(?=[^\s])/g, "$1 ")
    .replace(/\s{2,}/g, " ")
    .trim();
  return text;
}

let cachedVoices = [];

function refreshVoices() {
  if ("speechSynthesis" in window) {
    cachedVoices = window.speechSynthesis.getVoices();
  }
}

function loadVoices() {
  refreshVoices();
  if (!cachedVoices.length && "speechSynthesis" in window) {
    window.speechSynthesis.onvoiceschanged = refreshVoices;
    refreshVoices();
  }
  return cachedVoices;
}

// Calm, confident prosody profiles — tuned for clarity, warmth, and trust
// Lower rate = calmer; pitch near 1.0 = natural; slight variation prevents monotone
const CALM_VOICE_PROFILES = {
  male: { rate: 0.91, pitch: 0.96, volume: 1 },
  female: { rate: 0.93, pitch: 1.04, volume: 1 },
};

// Per-tone voice modulation — so the selected AI tone is audible in speech.
// Each tone shifts rate/pitch/volume slightly around the calm base profile.
const TONE_PROSODY = {
  friendly: { rateMul: 1.0, pitchAdd: 0.04, volume: 1 },
  professional: { rateMul: 1.0, pitchAdd: 0, volume: 1 },
  humorous: { rateMul: 1.06, pitchAdd: 0.08, volume: 1 },
  minimalist: { rateMul: 0.97, pitchAdd: -0.02, volume: 1 },
  enthusiastic: { rateMul: 1.08, pitchAdd: 0.1, volume: 1 },
};

function normalizeTone(tone) {
  const t = String(tone || 'professional').toLowerCase().trim();
  if (TONE_PROSODY[t]) return t;
  return 'professional';
}

function applyToneProsody(rate, pitch, volume, tone) {
  const mod = TONE_PROSODY[normalizeTone(tone)];
  return {
    rate: Math.max(0.75, Math.min(1.15, rate * mod.rateMul)),
    pitch: Math.max(0.75, Math.min(1.35, pitch + mod.pitchAdd)),
    volume: mod.volume != null ? mod.volume : volume,
  };
}

// ─────────────────────────────────────────────────────────────────────────────
// FIXED VOICE REGISTRY — Mivan (male) & Mira (female) per language
// ENGLISH + KANNADA ONLY — deterministic, same voice on every device/network.
// Order = priority (first available wins).
// ─────────────────────────────────────────────────────────────────────────────
const FIXED_VOICE_REGISTRY = {
  "en-IN": {
    // English (India)
    female: [
      // Windows 11 / Edge — Natural voices (highest quality)
      "Microsoft Neerja Online (Natural) - English (India)",
      "Microsoft Neerja - English (India)",
      // Chrome / Android Google voices
      "Google English (India) Female",
      "Google en-IN Female",
      // Cross-platform fallbacks
      "Microsoft Aria Online (Natural) - English (United States)",
      "Google UK English Female",
      "Google US English",
      "Samantha",
    ],
    male: [
      "Microsoft Prabhat Online (Natural) - English (India)",
      "Microsoft Prabhat - English (India)",
      "Google English (India) Male",
      "Google en-IN Male",
      "Microsoft Guy Online (Natural) - English (United States)",
      "Google UK English Male",
      "Google US English Male",
    ],
  },
  "kn-IN": {
    // Kannada — native Kannada voices (sparse support → fallback to en-IN same gender)
    female: [
      "Microsoft Sapna Online (Natural) - Kannada (India)",
      "Microsoft Sapna - Kannada (India)",
      "Google Kannada Female",
      "Google ಕನ್ನಡ Female",
      "Google Kannada",
      // Fallback: same Mira voice in English if Kannada not on device
      "Microsoft Neerja Online (Natural) - English (India)",
      "Google UK English Female",
    ],
    male: [
      "Microsoft Gagan Online (Natural) - Kannada (India)",
      "Microsoft Gagan - Kannada (India)",
      "Google Kannada Male",
      "Google ಕನ್ನಡ Male",
      // Fallback: same Mivan voice in English if Kannada not on device
      "Microsoft Prabhat Online (Natural) - English (India)",
      "Google UK English Male",
    ],
  },
};

// Backwards-compat alias — so existing callers/tests that know these names still work
const VOICE_REGISTRY = FIXED_VOICE_REGISTRY;

// Gender heuristics — last-resort fallback (English + Kannada only)
const MALE_PATTERN =
  /(guy|tony|ravi|prabhat|davis|george|matthew|brian|daniel|oliver|microsoft david|gagan|google.*male|en-in.*male)/i;
const FEMALE_PATTERN =
  /(aria|jenny|sonia|neerja|kajal|nancy|zira|hazel|ava|emma|samantha|fiona|libby|serena|joanna|salli|amy|ana|sapna|microsoft.*female|google.*female|en-in.*female)/i;

function isMaleVoice(voice) {
  return MALE_PATTERN.test(voice.name) || /male/i.test(voice.name);
}
function isFemaleVoice(voice) {
  return (
    FEMALE_PATTERN.test(voice.name) ||
    /female/i.test(voice.name) ||
    (!isMaleVoice(voice) && /(aria|jenny|sonia|zira|sapna)/i.test(voice.name))
  );
}

function normalizeForMatch(str) {
  return (str || "").toLowerCase().replace(/\s+/g, " ").trim();
}

// Try to find a voice whose name or voiceURI exactly equals (or contains) a registry entry.
// Returns the voice object or null.
function findFixedVoice(voices, candidates) {
  if (!candidates || !candidates.length) return null;
  // Pass 1: exact name or voiceURI match (case-insensitive)
  for (const cand of candidates) {
    const nCand = normalizeForMatch(cand);
    const hit = voices.find(
      (v) =>
        normalizeForMatch(v.name) === nCand ||
        normalizeForMatch(v.voiceURI) === nCand,
    );
    if (hit) return hit;
  }
  // Pass 2: substring / contains match (registry token inside voice name)
  for (const cand of candidates) {
    const nCand = normalizeForMatch(cand);
    // Only do substring if candidate is reasonably specific (>6 chars)
    if (nCand.length < 6) continue;
    const hit = voices.find((v) => normalizeForMatch(v.name).includes(nCand));
    if (hit) return hit;
  }
  // Pass 3: keyword match — e.g. "Neerja" matches any voice containing "neerja"
  for (const cand of candidates) {
    const keyword = normalizeForMatch(cand).split(" ")[1] || normalizeForMatch(cand);
    if (keyword.length < 4) continue;
    const hit = voices.find((v) => normalizeForMatch(v.name).includes(keyword));
    if (hit) return hit;
  }
  return null;
}

function scoreVoice(voice, opts = {}) {
  const { preferredGender, speechLanguage } = opts;
  const name = voice.name.toLowerCase();
  const lang = (voice.lang || "").toLowerCase();
  let score = 0;

  // Language match — prioritize user's selected language
  const targetLang = (speechLanguage || "en-IN").toLowerCase();
  if (lang === targetLang) score += 140;
  else if (lang.startsWith(targetLang.slice(0, 2))) score += 40;
  if (lang.startsWith("en-in")) score += 120;
  else if (lang.startsWith("en-us")) score += 60;
  else if (lang.startsWith("en-gb")) score += 55;
  else if (lang.startsWith("en")) score += 30;
  // Kannada voice bonus
  if (targetLang.startsWith("kn") && lang.startsWith("kn")) score += 80;

  if (/natural|neural|online|premium|enhanced|hd/.test(name)) score += 40;
  if (/google/.test(name)) score += 35;
  if (/microsoft/.test(name)) score += 20;

  const preferred =
    /(aria|jenny|guy|tony|sonia|ravi|neerja|kajal|prabhat|nancy|zira|hazel|ava|emma|davis|samantha|daniel|fiona|oliver|libby|george|serena|joanna|matthew|salli|amy|brian|emma|ana|sapna|gagan)/;
  if (preferred.test(name)) score += 15;

  if (/premium|enhanced/.test(name)) score += 10;

  // Prefer the requested identity even when several voices share a language.
  if (preferredGender === "male" && isMaleVoice(voice)) score += 180;
  if (preferredGender === "female" && isFemaleVoice(voice)) score += 180;
  if (preferredGender === "male" && isFemaleVoice(voice)) score -= 120;
  if (preferredGender === "female" && isMaleVoice(voice)) score -= 120;

  return score;
}

function pickBestVoice(prefs = {}) {
  const voices = loadVoices();
  if (!voices.length) return null;
  const speechLanguage = prefs.speechLanguage || "en-IN";
  const preferredGender = prefs.assistantVoice || prefs.voice || null;
  const normalizedLang = FIXED_VOICE_REGISTRY[speechLanguage]
    ? speechLanguage
    : "en-IN";
  const gender = preferredGender === "male" ? "male" : "female";

  // 1) FIXED REGISTRY — deterministic, same voice on every device
  const candidates = FIXED_VOICE_REGISTRY[normalizedLang]?.[gender];
  const fixed = findFixedVoice(voices, candidates);
  if (fixed) return fixed;

  // 2) Fallback: try other language registry for same gender (e.g. kn-IN missing → en-IN)
  if (normalizedLang !== "en-IN") {
    const fallback = findFixedVoice(
      voices,
      FIXED_VOICE_REGISTRY["en-IN"][gender],
    );
    if (fallback) return fallback;
  }

  // 3) Last resort: deterministic scoring (no randomness) — still respects gender + language
  const opts = { preferredGender: gender, speechLanguage };
  return voices
    .slice()
    .sort((a, b) => scoreVoice(b, opts) - scoreVoice(a, opts))[0];
}

function getVoiceProfile(gender) {
  return CALM_VOICE_PROFILES[gender] || CALM_VOICE_PROFILES.female;
}

// Expose registry + helpers for debugging / settings preview
function getFixedVoiceRegistry() {
  return JSON.parse(JSON.stringify(FIXED_VOICE_REGISTRY));
}
function getVoiceForLanguage(speechLanguage, assistantVoice) {
  return pickBestVoice({ speechLanguage, assistantVoice });
}

// ── Spoken-text language detection ─────────────────────────────────────
// A conversation can hold English replies while the voice setting is now
// Kannada (or vice versa). Speaking English text with a Kannada voice — or
// the reverse — sounds broken, so detect the TEXT language and let it win
// when it clearly disagrees with the setting. Returns 'en-IN' | 'kn-IN' |
// null (too short / mixed → keep the caller's setting).
function detectSpeechLanguage(rawText) {
  const t = String(rawText || "");
  const kn = (t.match(/[\u0C80-\u0CFF]/g) || []).length;
  const lat = (t.match(/[A-Za-z]/g) || []).length;
  const total = kn + lat;
  if (total < 4) return null;
  if (kn >= 3 && kn / total >= 0.2) return "kn-IN";
  if (lat >= 3 && lat / total >= 0.7) return "en-IN";
  return null;
}

// Effective voice language: text script wins when conclusive, else setting.
function resolveSpeechLanguage(rawText, speechLanguage) {
  const fallback = speechLanguage === "kn-IN" ? "kn-IN" : "en-IN";
  const detected = detectSpeechLanguage(rawText);
  if (detected && detected !== fallback) return detected;
  return fallback;
}

// ── Natural phrasing & modulation helpers ──

function getSentenceType(text) {
  const t = (text || "").trim();
  if (t.endsWith("?")) return "question";
  if (t.endsWith("!")) return "exclamation";
  if (t.endsWith(":")) return "list";
  return "statement";
}

function getPauseMs(chunk, nextChunk) {
  const type = getSentenceType(chunk);
  const nextStartsSentence =
    Boolean(nextChunk) && /^[A-Z0-9]/.test(nextChunk.trim());
  const lengthBreath = chunk.length > 115 ? 120 : 0;

  // Proper space/gap while speaking — questions and exclamations breathe
  // longer, plain statements get a clear beat so replies sound smarter.
  if (type === "question") return 600 + lengthBreath;
  if (type === "exclamation") return 520 + lengthBreath;
  if (type === "list") return 450 + lengthBreath;
  if (/[,;:]$/.test(chunk.trim())) return 320;
  return nextStartsSentence ? 430 + lengthBreath : 340;
}

function getProsody(chunk, baseRate, basePitch, idx) {
  const type = getSentenceType(chunk);
  let rate = baseRate;
  let pitch = basePitch;

  // Small deterministic changes keep longer answers from sounding synthetic.
  const variation = [0, 0.012, -0.009, 0.006][idx % 4];
  pitch += variation;
  rate *= [1, 0.985, 1.01, 0.992][idx % 4];

  // Questions: lift pitch slightly at end, slow a touch for clarity
  if (type === "question") {
    pitch += 0.06;
    rate *= 0.97;
  }
  // Exclamations: a bit more energetic but still controlled
  if (type === "exclamation") {
    pitch += 0.03;
    rate *= 1.02;
  }
  // Long sentences: slow down for comprehension (calm)
  if (chunk.length > 140) rate *= 0.96;
  if (chunk.length > 180) rate *= 0.97;

  // Numbers / amounts: slow down for clarity
  if (/rupees|\d{3,}/.test(chunk)) rate *= 0.94;

  // Clamp to natural bounds
  rate = Math.max(0.75, Math.min(1.15, rate));
  pitch = Math.max(0.75, Math.min(1.35, pitch));

  return { rate, pitch };
}

function chunkForSpeech(text, maxLength = 160) {
  // Split on sentence boundaries first, then on commas/semicolons for long sentences
  const rawSentences = text.split(/(?<=[.!?])\s+/).filter(Boolean);
  const chunks = [];
  for (const sent of rawSentences) {
    if (sent.length <= maxLength) {
      chunks.push(sent.trim());
      continue;
    }
    // Long sentence: break on commas / "and" / natural phrase boundaries
    const parts = sent.split(/,\s+|\s+and\s+|\s+—\s+|\s+;\s+/);
    let cur = "";
    for (const p of parts) {
      const withComma = cur ? `${cur}, ${p}` : p;
      if (withComma.length > maxLength && cur) {
        chunks.push(cur.trim());
        cur = p;
      } else {
        cur = withComma;
      }
    }
    if (cur) chunks.push(cur.trim());
  }
  // Merge tiny fragments (<35 chars) with next to avoid choppy cadence
  const merged = [];
  for (let i = 0; i < chunks.length; i++) {
    const c = chunks[i];
    if (c.length < 35 && i + 1 < chunks.length) {
      merged.push(`${c} ${chunks[i + 1]}`.trim());
      i++;
    } else {
      merged.push(c);
    }
  }
  return merged.filter(Boolean);
}

function speakSmart(rawText, opts = {}) {
  const { onEnd, onError, onPause, onResume } = opts;
  // Calm, confident defaults — override via opts or voice profile
  const voiceGender = opts.assistantVoice || opts.voice || null;
  // Voice follows the TEXT when it clearly disagrees with the setting
  // (e.g. an old English reply played after switching to Kannada).
  const speechLanguage = opts.strictLanguage
    ? (opts.speechLanguage || "en-IN")
    : resolveSpeechLanguage(rawText, opts.speechLanguage || "en-IN");
  const tone = normalizeTone(opts.tone);
  const profile = getVoiceProfile(voiceGender);
  let baseRate = opts.rate != null ? opts.rate : profile.rate;
  let basePitch = opts.pitch != null ? opts.pitch : profile.pitch;
  let baseVolume = opts.volume != null ? opts.volume : profile.volume;
  // Modulate voice to match the selected AI tone
  const modulated = applyToneProsody(baseRate, basePitch, baseVolume, tone);
  baseRate = modulated.rate;
  basePitch = modulated.pitch;
  baseVolume = modulated.volume;

  const noop = () => {};
  if (!("speechSynthesis" in window)) {
    const ctrl = { cancel: noop, pause: noop, resume: noop, get paused() { return false; }, get speaking() { return false; } };
    const fn = () => ctrl.cancel();
    Object.assign(fn, ctrl);
    return fn;
  }
  const text = smartSpeechText(rawText, speechLanguage);
  if (!text) {
    onEnd && onEnd();
    const ctrl = { cancel: noop, pause: noop, resume: noop, get paused() { return false; }, get speaking() { return false; } };
    const fn = () => ctrl.cancel();
    Object.assign(fn, ctrl);
    return fn;
  }

  const chunks = chunkForSpeech(text);
  const voice = pickBestVoice({ assistantVoice: voiceGender, speechLanguage });
  let index = 0;
  let cancelled = false;
  let paused = false;
  let timer = null;
  let pendingGap = false;

  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const speakNext = () => {
    if (cancelled || paused) return;
    if (index >= chunks.length) {
      onEnd && onEnd();
      return;
    }
    const chunk = chunks[index];
    const { rate, pitch } = getProsody(chunk, baseRate, basePitch, index);

    const utterance = new SpeechSynthesisUtterance(chunk);
    if (voice) {
      utterance.voice = voice;
      utterance.lang = voice.lang;
    }
    utterance.rate = rate;
    utterance.pitch = pitch;
    utterance.volume = baseVolume;

    utterance.onend = () => {
      if (cancelled || paused) return;
      index++;
      if (index >= chunks.length) {
        onEnd && onEnd();
        return;
      }
      const pause = getPauseMs(chunk, chunks[index]);
      timer = setTimeout(speakNext, pause);
    };
    utterance.onerror = (e) => {
      if (cancelled) return;
      if (
        e.error !== "canceled" &&
        e.error !== "interrupted" &&
        e.error !== "not-allowed"
      ) {
        onError && onError(e);
      }
      // "canceled"/paused interruptions should not fire onEnd if we are paused
      if (!paused) onEnd && onEnd();
    };

    window.speechSynthesis.speak(utterance);
  };

  window.speechSynthesis.cancel();
  // A short onset pause gives the voice a natural conversational turn-taking cue.
  timer = setTimeout(speakNext, 180);

  const cancel = () => {
    if (cancelled) return;
    cancelled = true;
    paused = false;
    pendingGap = false;
    clearTimer();
    window.speechSynthesis.cancel();
  };

  const pause = () => {
    if (cancelled || paused) return;
    paused = true;
    // If currently speaking, pause native synthesis
    try {
      if (window.speechSynthesis.speaking && !window.speechSynthesis.paused) {
        window.speechSynthesis.pause();
      }
    } catch {}
    // If we are in the gap between chunks, keep the next chunk pending
    if (timer) {
      clearTimer();
      pendingGap = true;
    }
    onPause && onPause();
  };

  const resume = () => {
    if (cancelled || !paused) return;
    paused = false;
    try {
      if (window.speechSynthesis.paused) {
        window.speechSynthesis.resume();
        onResume && onResume();
        return;
      }
    } catch {}
    // We were paused during inter-chunk gap
    if (pendingGap) {
      pendingGap = false;
      onResume && onResume();
      timer = setTimeout(speakNext, 120);
      return;
    }
    // If nothing is speaking but we have remaining chunks (e.g. paused right after onend cleared timer)
    if (!window.speechSynthesis.speaking && index < chunks.length) {
      onResume && onResume();
      // If we paused before current utterance finished, resume already handled.
      // Otherwise continue to next chunk
      const isStillOnSameChunk = window.speechSynthesis.pending || window.speechSynthesis.speaking;
      if (!isStillOnSameChunk) {
        timer = setTimeout(speakNext, 80);
      }
    } else {
      onResume && onResume();
    }
  };

  const controller = {
    cancel,
    pause,
    resume,
    get paused() { return paused; },
    get speaking() { return !cancelled && (window.speechSynthesis.speaking || window.speechSynthesis.pending || index < chunks.length); },
  };
  // Backwards compat: allow calling controller as function to cancel
  const fn = () => cancel();
  Object.assign(fn, controller);
  // Also expose methods directly on function
  fn.cancel = cancel;
  fn.pause = pause;
  fn.resume = resume;
  return fn;
}

export {
  pickBestVoice,
  speakSmart,
  getVoiceProfile,
  detectSpeechLanguage,
  resolveSpeechLanguage,
  normalizeTone as normalizeSpeechTone,
  applyToneProsody,
  TONE_PROSODY,
  CALM_VOICE_PROFILES,
  FIXED_VOICE_REGISTRY,
  VOICE_REGISTRY,
  getFixedVoiceRegistry,
  getVoiceForLanguage,
  findFixedVoice,
};
export default smartSpeechText;
